export default __webpack_public_path__ + "static/media/logo-topbar.bd0f5223.svg";